import React from 'react'
import BaseButton from './BaseButton'

function PrimaryButton(props) {
  const { light, outline, ...rest } = props
  return outline ? (
    <BaseButton
      {...rest}
      className={`${
        props.light
          ? 'text-primary bg-transparent border-primary-light hover:border-primary'
          : 'text-primary bg-transparent border-primary hover:bg-primary-lighter hover:border-primary-dark'
      }`}
    />
  ) : (
    <BaseButton
      {...rest}
      className={`${
        props.light
          ? 'text-primary-dark bg-primary-lighter border-primary-lighter hover:bg-primary-lightest hover:border-primary-lightest'
          : 'text-white bg-primary border-primary hover:bg-primary-dark hover:border-primary-dark'
      }`}
    />
  )
}

export default PrimaryButton
